import {http} from '../utils'

const getAuditLogType = () => {
  const url = '/config/auditLog/getType'
  return http.post(url)
}

const getAuditUsers = () => {
  const url = '/api/v1/users/all'
  return http.post(url)
}

const auditLogPage = params => {
  const url = '/config/auditLog/auditLogPage'
  return http.post(url, params)
}

const insertAuditLog = params => {
  const url = '/api/v1/log/save'
  return http.post(url, params)
}

const auditLogExport = () => {
  const url = '/api/v1/report/export'
  return http.post(url)
}

export default {
  getAuditLogType,
  getAuditUsers,
  auditLogPage,
  insertAuditLog,
  auditLogExport,
}
